import { render, staticRenderFns } from "./DeclineRefund.vue?vue&type=template&id=47641718&scoped=true"
import script from "./DeclineRefund.vue?vue&type=script&lang=js"
export * from "./DeclineRefund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47641718",
  null
  
)

export default component.exports